export function map() {
    let mapStyle = [
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#0096aa"
                },
                {
                    "weight": "0.30"
                },
                {
                    "saturation": "-75"
                },
                {
                    "lightness": "5"
                },
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#0096aa"
                },
                {
                    "saturation": "-75"
                },
                {
                    "lightness": "5"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#ffe146"
                },
                {
                    "visibility": "on"
                },
                {
                    "weight": "6"
                },
                {
                    "saturation": "-28"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#e6007e"
                },
                {
                    "weight": "1"
                }
            ]
        },
        {
            "featureType": "administrative.country",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "gamma": "7.47"
                },
                {
                    "hue": "#ff0000"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#ff0000"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#ffe146"
                },
                {
                    "saturation": "-28"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#edda09"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#0096aa"
                },
                {
                    "visibility": "simplified"
                },
                {
                    "saturation": "-75"
                },
                {
                    "lightness": "5"
                },
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#31313f"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#ffe146"
                },
                {
                    "weight": 8
                },
                {
                    "saturation": "-28"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#31313f"
                },
                {
                    "weight": 8
                },
                {
                    "lightness": "5"
                },
                {
                    "gamma": "1"
                },
                {
                    "saturation": "-75"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#edda09"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "color": "#0096aa"
                },
                {
                    "saturation": "-75"
                },
                {
                    "lightness": "5"
                },
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#31313f"
                },
                {
                    "saturation": "-75"
                },
                {
                    "lightness": "5"
                },
                {
                    "gamma": "1"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "color": "#ffe146"
                },
                {
                    "saturation": "-28"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ];

    function createMap(map) {
        let position = {
                lat: map.data("pin-lat") * 1,
                lng: map.data("pin-lng") * 1
            },
            curMmap = new google.maps.Map(map[0], {
                styles: mapStyle,
                zoom: map.data("zoom") * 1,
                scrollwheel: false,
                scaleControl: false,
                draggable: !((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf("IEMobile") !== -1)),
                zoomControl: false,
                disableDoubleClickZoom: true,
                panControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                overviewMapControl: false,
                fullscreenControl: false,
                center: position
            });

        new google.maps.Marker({
            position: {
                lat: map.data("pin-lat") * 1,
                lng: map.data("pin-lng") * 1
            },
            map: curMmap,
            icon: map.data("pin-url")
        });
    }

    window.initializeMap = function () {
        createMap($(".map"));
    };

}


// WEBPACK FOOTER //
// ./assets/js/modules/map.js